import { Component, ViewChild, Input, TemplateRef, Renderer2, ElementRef, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { StaticAuditTrailComponent } from '../support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { PaginationService } from '../PaginationService';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
import { DatePipe } from '@angular/common';
import { forkJoin } from 'rxjs';
import { EditorComponent } from '../editor/editor.component';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { parseFieldSpecs } from '@fullcalendar/core/internal';
import { SessionTimeoutService } from '../session-timeout-dialog/session-timeout.service';

export interface PopupData {
  title: string;
}
@Component({
  selector: 'app-oneqms-organization',
  templateUrl: './oneqms-organization.component.html',
  styleUrls: ['./oneqms-organization.component.scss']
})

export class OneqmsOrganizationComponent implements OnInit, AfterViewInit, OnDestroy {

  isProcessing: boolean = false;

  constructor(public appService: AppService, public dialog: MatDialog, private readonly elem: ElementRef, public snackBar: MatSnackBar, public message: messageService, private readonly renderer: Renderer2, public paginationService: PaginationService, public datePipe: DatePipe, private readonly sessionTimeoutService: SessionTimeoutService) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  organization: any = {};
  organizationImage: any = {};
  organizationPrivilege: any = {};
  organizationReportImage: any = {};
  orgIpAddress: any = {};

  dropDownForTimezone: any = [];
  dropDownForCountry: any = [];
  dropDownForDateFormat: any = [];
  dropDownForNameFormat: any = [];
  dropDownForModules: any = [];
  dropdownForQmsGroup: any = [];
  dropdownForDmsFolder: any = [];
  dropDownListForAD: any = [];

  timeZoneDropdown: any = [];
  orgCountriesDropdown: any = [];
  dateFormatDropdown: any = [];
  nameFormatDropdown: any = [];
  modulesDropdown: any = [];
  qmsGroupDropdown: any = [];
  dmsFolderDropdown: any = [];
  adListDropdown: any = [];

  selectedTimeZone: any = null;
  selectedOrgCountries: any = [];
  selectedDateFormat: any = null;
  selectedNameFormatForApp: any = null;
  selectedNameFormatForRep: any = null;
  selectedModule: any = [];
  selectedQmsGroup: any = [];
  selectedDmsFolder: any = [];
  selectedADType: any = [];

  reportsTimeZoneSearchText: string = '';
  orgCountriesSearchText: string = '';
  dateFormatSearchText: string = '';
  userNameApplicationSearchText: string = '';
  userNameFormatForRepSearchText: string = '';
  modulesSearchText: string = "";
  documentsSearchText: string = "";
  adSearchText: string = "";
  sessionSearchText: string = "";

  isQuality: boolean;
  params: any
  filteredDropDownValueForAd: any = [];
  hideIfDevLogin: any;
  currentDate: Date = new Date();
  remainingDays: any;
  licenseExpiryDateStatus: string = '';

  oddTimeZone: any = null;
  oddNameFormatForApp: any = null;
  oddNameFormatForRep: any = null;
  oddDateFormat: any = null;
  selectedTabIndex: number = 0;

  sessionArray: any = [1, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];

  onTabChanged($event: any) {
    this.selectedTabIndex = $event.index;
    $event.index == 2 && this.setOrgReportImageGrid();
    $event.index == 4 && this.setIPGrid();
  }

  refreshForm() {
    this.ngOnInit();
  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {

    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.isProcessing = true;

    const getOneQmsOrg$ = this.appService.getOneQmsOrganization();
    const getOneQmsOrgPrivilege$ = this.appService.getOneQmsOrganizationPrivileges();
    const getOneQmsOrgImages$ = this.appService.getAllOrgReportImages();
    const getAdTypeCodeList$ = this.appService.getNonOrgCodeListsByGroupName("AD_TYPE");
    const getOrgRepImgModule$ = this.appService.getOrgRepImgModule();
    const getQmsGroups$ = this.appService.getQmsGroups();
    const getDmsFolders$ = this.appService.getDocumentFolderRepVw(null, "val");

    forkJoin([
      getOneQmsOrg$,
      getOneQmsOrgPrivilege$,
      getOneQmsOrgImages$,
      getAdTypeCodeList$,
      getOrgRepImgModule$,
      getQmsGroups$,
      getDmsFolders$
    ]).subscribe(([org, orgPrivilege, orgImage, adType, repImageModule, qmsGroup, dmsFolder]) => {

      this.dropDownForTimezone = JSON.parse(sessionStorage.getItem('dropDownForReportTimezone') ?? '{}');
      this.selectBoxForTimeZone();

      this.dropDownForNameFormat = JSON.parse(sessionStorage.getItem('dropDownForUserNameFormat') ?? '{}');
      this.selectBoxForNameFormat();

      this.dropDownForDateFormat = JSON.parse(sessionStorage.getItem('dropDownForDateFormat') ?? '{}');
      this.selectBoxForDateFormat();

      this.dropDownForCountry = JSON.parse(sessionStorage.getItem('dropDownForCountry') ?? '{}');
      this.selectBoxForOrgCountries();

      this.dropDownListForAD = adType;
      this.selectBoxForADType();


      this.dropdownForQmsGroup = qmsGroup;
      this.selectBoxForQmsGroup();

      this.dropdownForDmsFolder = dmsFolder;
      this.selectBoxForDmsFolder();

      this.setOrgDetails(org);
      this.setOrgPrivileges(orgPrivilege);

      this.dropDownForModules = repImageModule;
      this.selectBoxForRepImgModule();

      this.setOrgImages(orgImage);

      this.selectBoxForSessionTimeout();

      this.isProcessing = false;
    });
  }

  setOrgDetails(org: any) {
    this.organization = org;

    this.organization.sameEmailToMultipleUsers = this.organization.sameEmailToMultipleUsers == "Y";
    this.organization.isActive = this.organization.isActive == "Y";
    this.organization.adEnabled = this.organization.adEnabled == "Y";
    this.organization.stopEmails = this.organization.stopEmails == "Y";
    this.organization.allowUserInParallelSession = this.organization.allowUserInParallelSession == "Y";
    this.organization.hideUserName = this.organization.hideUserName == "Y";
    this.organization.isAllowMobileAccess = this.organization.isAllowMobileAccess == "Y";
    this.organization.isDocumentPasswordReqd = this.organization.isDocumentPasswordReqd == "Y";
    this.organization.licenseStartedOn = this.organization.licenseStartedOn ? new Date(this.organization.licenseStartedOn.split('T')) : null;
    this.organization.licenseRenewedOn = this.organization.licenseRenewedOn ? new Date(this.organization.licenseRenewedOn.split('T')) : null;
    this.organization.versionUpgradedOn = this.organization.versionUpgradedOn ? new Date(this.organization.versionUpgradedOn.split('T')) : null;
    this.organization.licenseExpiryDate = this.organization.licenseExpiryDate ? new Date(this.organization.licenseExpiryDate.split('T')) : null;

    this.selectedOrgCountries = this.organization.orgCountries ? this.organization.orgCountries.split(",") : [];
    this.organization.orgCountries && setTimeout(() => { this.isAllOrgCountriesSelected = this.orgCountriesDropdown.length == this.selectedOrgCountries.length });

    this.hideIfDevLogin = this.organization.applicationUrl?.includes('predev.one-qms.com/login');
    this.organization.updateReason = '';

    this.setLicenseWarning(this.organization.licenseExpiryDate);
    this.setDropdowns();
  }

  setLicenseWarning(licenseExpiryDate: any) {
    if (licenseExpiryDate) {
      const currentDate: Date = new Date();

      licenseExpiryDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);

      if (licenseExpiryDate > currentDate) {
        this.licenseExpiryDateStatus = "Future";
        const timeDifference = licenseExpiryDate.getTime() - this.currentDate.getTime();
        this.remainingDays = Math.ceil(timeDifference / (1000 * 3600 * 24));
      } else if (licenseExpiryDate < currentDate) {
        this.licenseExpiryDateStatus = "Past";
        this.licenseExpiryValidation();
      } else {
        this.licenseExpiryDateStatus = "Present";
        this.licenseExpiryValidation();
      }
    } else {
      this.licenseExpiryDateStatus = '';
    }
  }

  focusEmpty() {
    console.log();
  }
  setDropdowns() {
    if (this.organization.notificationTimezone) {
      const matchingTimeZone = this.dropDownForTimezone?.find((timeZone: any) => timeZone.codelistCode == this.organization.notificationTimezone);
      if (!matchingTimeZone) {
        this.oddTimeZone = this.organization.notificationTimezone;
        this.timeZoneDropdown.push({
          valueExp: this.organization.notificationTimezone,
          displayExp: this.organization.notificationTimezone
        })
      }
      this.selectedTimeZone = this.organization.notificationTimezone;
    } else {
      this.selectedTimeZone = null;
    }

    if (this.organization.userNameFormatAtApplication) {
      const matchingUserNameFormatAtApplication = this.dropDownForNameFormat?.find((item: any) => item.codelistCode == this.organization.userNameFormatAtApplication);
      if (!matchingUserNameFormatAtApplication) {
        this.oddNameFormatForApp = this.organization.userNameFormatAtApplication;
        this.nameFormatDropdown.push({
          valueExp: this.organization.userNameFormatAtApplication,
          displayExp: this.organization.userNameFormatAtApplication
        })
      }
      this.selectedNameFormatForApp = this.organization.userNameFormatAtApplication;
    } else {
      this.selectedNameFormatForApp = null;
    }

    if (this.organization.userNameFormatAtReports) {
      const matchingUserNameFormatAtReports = this.dropDownForNameFormat?.find((item: any) => item.codelistCode == this.organization.userNameFormatAtReports);
      if (!matchingUserNameFormatAtReports) {
        this.oddNameFormatForRep = this.organization.userNameFormatAtReports;
        this.nameFormatDropdown.push({
          valueExp: this.organization.userNameFormatAtReports,
          displayExp: this.organization.userNameFormatAtReports
        })
      }
      this.selectedNameFormatForRep = this.organization.userNameFormatAtReports;
    } else {
      this.selectedNameFormatForRep = null;
    }

    if (this.organization.dateFormat) {
      const matchingDateFormat = this.dropDownForDateFormat?.find((item: any) => item.codelistCode == this.organization.dateFormat);
      if (!matchingDateFormat) {
        this.oddDateFormat = this.organization.dateFormat;
        this.dateFormatDropdown.push({
          valueExp: this.organization.dateFormat,
          displayExp: this.organization.dateFormat
        })
      }
      this.selectedDateFormat = this.organization.dateFormat;
    } else {
      this.selectedDateFormat = null;
    }

    if (this.organization.adType) {
      const matchingAdType = this.dropDownListForAD?.find((item: any) => item.codelistCode == this.organization.adType);
      if (!matchingAdType) {
        this.adListDropdown.push({
          valueExp: this.organization.adType,
          displayExp: this.organization.adTypes
        })
      }
      this.selectedADType = this.organization.adType;
    } else {
      this.selectedADType = null;
    }
  }

  setOrgPrivileges(privilege: any) {
    this.organizationPrivilege = privilege;

    this.organizationPrivilege.cr = this.organizationPrivilege.cr == "Y";
    this.organizationPrivilege.capa = this.organizationPrivilege.capa == "Y";
    this.organizationPrivilege.dv = this.organizationPrivilege.dv == "Y";
    this.organizationPrivilege.au = this.organizationPrivilege.au == "Y";
    this.organizationPrivilege.in = this.organizationPrivilege.in == "Y";
    this.organizationPrivilege.qi = this.organizationPrivilege.qi == "Y";
    this.organizationPrivilege.cc = this.organizationPrivilege.cc == "Y";
    this.organizationPrivilege.trn = this.organizationPrivilege.trn == "Y";
    this.organizationPrivilege.docs = this.organizationPrivilege.docs == "Y";
    this.organizationPrivilege.formsAndLogs = this.organizationPrivilege.formsAndLogs == "Y";
    this.organizationPrivilege.bp = this.organizationPrivilege.bp == "Y";
    this.organizationPrivilege.oos = this.organizationPrivilege.oos == "Y";
    this.isQuality = this.organizationPrivilege.cr || this.organizationPrivilege.capa || this.organizationPrivilege.dv || this.organizationPrivilege.au || this.organizationPrivilege.in || this.organizationPrivilege.qi || this.organizationPrivilege.cc || this.organizationPrivilege.oos;
  }

  setOrgImages(orgImage: any) {
    this.organizationImage = orgImage;
    console.log("this.organizationImage → ", this.organizationImage);
    if (this.organizationImage) {
      this.organizationImage.isLoginImageSquare = this.organizationImage.isLoginImageSquare == "Y";
      this.organizationImage.isReportImageSquare = this.organizationImage.isReportImageSquare == "Y";
      this.organizationImage.isLogoImageSquare = this.organizationImage.isLogoImageSquare == "Y";
      this.viewerData = {
        body: this.organizationImage.clientUserGuide,
        contentType: 'application/pdf',
        extn: 'pdf'
      };
    } else {
      this.organizationImage = { loginpageContent: "" };
    }
  }

  setOrgReportImageGrid() {
    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (orgReportImage: any) => {
        this.organizationReportImage = orgReportImage;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.organizationReportImage.length;
        this.totalPages = Math.ceil(this.organizationReportImage.length / this.itemsPerPage);
        this.setReportImagePage(1, 0);
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  selectBoxForOrgCountries() {
    this.orgCountriesDropdown = [];
    this.orgCountriesDropdown = this.dropDownForCountry?.map((country: any) => ({
      valueExp: country.codelistCode,
      displayExp: country.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  onOrgCountriesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isAllOrgCountriesSelected = this.orgCountriesDropdown.length == this.selectedOrgCountries.length;
      })
    }
  }

  selectBoxForTimeZone() {
    this.timeZoneDropdown = [];
    this.timeZoneDropdown = this.dropDownForTimezone.map((timeZone: any) => ({
      valueExp: timeZone.codelistCode,
      displayExp: timeZone.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  selectBoxForDateFormat() {
    this.dateFormatDropdown = [];
    this.dateFormatDropdown = this.dropDownForDateFormat.map((dateFormat: any) => ({
      valueExp: dateFormat.codelistCode,
      displayExp: dateFormat.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  selectBoxForNameFormat() {
    this.nameFormatDropdown = [];
    this.nameFormatDropdown = this.dropDownForNameFormat.map((nameFormat: any) => ({
      valueExp: nameFormat.codelistCode,
      displayExp: nameFormat.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  selectBoxForADType() {
    this.adListDropdown = [];
    this.adListDropdown = this.dropDownListForAD.map((ad: any) => ({
      valueExp: ad.codelistCode,
      displayExp: ad.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  selectBoxForRepImgModule() {
    this.modulesDropdown = [];
    this.modulesDropdown = this.dropDownForModules.map((module: any) => ({
      valueExp: module.moduleCode,
      displayExp: module.moduleName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
    if (!this.isQuality) {
      this.modulesDropdown = this.modulesDropdown.filter((item: { displayExp: string; }) => item.displayExp !== 'Quality');
    }
    if (!this.organizationPrivilege.trn) {
      this.modulesDropdown = this.modulesDropdown.filter((item: { displayExp: string; }) => item.displayExp !== 'Trainings');
    }
    if (!this.organizationPrivilege.docs) {
      this.modulesDropdown = this.modulesDropdown.filter((item: { displayExp: string; }) => item.displayExp !== 'Documents');
    }

    if (!this.organizationPrivilege.formsAndLogs) {
      this.modulesDropdown = this.modulesDropdown.filter((item: { displayExp: string; }) => item.displayExp !== 'Forms and Logs');
    }
    if (!this.organizationPrivilege.bp) {
      this.modulesDropdown = this.modulesDropdown.filter((item: { displayExp: string; }) => item.displayExp !== 'Business Processes');
    }
    if (!this.organizationPrivilege.oos) {
      this.modulesDropdown = this.modulesDropdown.filter((item: { displayExp: string; }) => item.displayExp !== 'oos');
    }
  }

  onModulesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.isAllModulesSelected = this.modulesDropdown.length == this.selectedModule.length })
      if (item) {
        setTimeout(() => {
          if (this.selectedModule.length == 1) {
            this.singleSelected = this.selectedModule[0];
          } else {
            [this.selectedQmsGroup, this.selectedDmsFolder] = [[], []];
          }
        })
      }
    }
  }

  selectBoxForQmsGroup() {
    this.qmsGroupDropdown = [];
    this.qmsGroupDropdown = this.dropdownForQmsGroup.map((group: any) => ({
      valueExp: group.groupId,
      displayExp: group.groupName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  onGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.groupValueRequiredMsg != undefined) {
        this.groupValueRequiredMsg.style.display = 'none';
      }
      setTimeout(() => {
        this.isAllGroupSelected = this.qmsGroupDropdown.length == this.selectedQmsGroup.length;
      })
      if (!item) {
        event.source.value = null;
        this.organizationReportImage.moduleRefIds = '';
      }
    }
  }

  selectBoxForDmsFolder() {
    this.dmsFolderDropdown = [];
    this.dmsFolderDropdown = this.dropdownForDmsFolder.map((folder: any) => ({
      valueExp: folder.folderId,
      displayExp: folder.folderName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  onDocumentsSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.documentsValueRequiredMsg != undefined) {
        this.documentsValueRequiredMsg.style.display = 'none';
      }
      setTimeout(() => {
        this.isAllDocumentsSelected = this.dmsFolderDropdown.length == this.selectedDmsFolder.length;
      })
      if (!item) {
        event.source.value = null;
        this.organizationReportImage.moduleRefIds = '';
      }
    }
  }

  @ViewChild('columns') columns: MatSelect;
  @ViewChild('modules') modules: MatSelect;
  @ViewChild('groups') groups: MatSelect;
  @ViewChild('documents') documents: MatSelect;
  isAllColumns = false;
  toggleAllSelection(value: any) {
    if (value == 'organizationCountry') {
      if (this.isAllOrgCountriesSelected) this.organizationCountry.options.forEach((item: MatOption) => item.select());
      else this.organizationCountry.options.forEach((item: MatOption) => item.deselect());
    } else if (value == 'modules') {
      if (this.moduleValueRequiredMsg != undefined) {
        this.moduleValueRequiredMsg.style.display = 'none';
      }
      if (this.isAllModulesSelected) this.modules.options.forEach((item: MatOption) => item.select());
      else this.modules.options.forEach((item: MatOption) => item.deselect());
    } else if (value == 'group') {
      if (this.groupValueRequiredMsg != undefined) {
        this.groupValueRequiredMsg.style.display = 'none';
      }
      if (this.isAllGroupSelected) this.groups.options.forEach((item: MatOption) => item.select());
      else this.groups.options.forEach((item: MatOption) => item.deselect());
    } else if (value == 'documents') {
      if (this.documentsValueRequiredMsg != undefined) {
        this.documentsValueRequiredMsg.style.display = 'none';
      }
      if (this.isAllDocumentsSelected) this.documents.options.forEach((item: MatOption) => item.select());
      else this.documents.options.forEach((item: MatOption) => item.deselect());
    }
  }

  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;
  visibleInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addAndEditDynamicPopup', { static: true }) addAndEditDynamicPopup: TemplateRef<any>;
  visibleAddAndEditPopupDynamic: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deleteDynamicPopup', { static: true }) deleteDynamicPopup: TemplateRef<any>;
  visibleDeletePopupDynamic: MatDialogRef<TemplateRef<any>>;
  @ViewChild('uploadImagesPopup', { static: true }) uploadImagesPopup: TemplateRef<any>;
  visibleUploadImagesPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('angularEditorTextarea', { static: true }) angularEditorTextarea: TemplateRef<any>;
  visibleAngularEditor: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  infoPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  addAndEditPopupDynamicConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  infoPopupDynamicConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  deletePopupDynamicConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  uploadImagesPopupConfig = {
    width: '30%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  angularEditorTextareaConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  buttonsExcludedConfig: EditorConfig = {
    buttons: [],
  };

  buttonsIncludedConfig: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;

      element && (element.style.color = 'red');
      !element && console.error('Unable to find the element. [fieldValidation()] Id → ', elementId);
    });
  }

  focusSearch(value: any) {
    setTimeout(() => { let requiredElement = document.getElementById(value); requiredElement?.focus(); }, 0)
  }

  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  editorValue: any;
  textareaEditorTitle: string;
  openEditor(value: any) {
    this.textareaEditorTitle = value;
    this.editorValue = value == "Login Page Content" ? this.organizationImage.loginpageContent : '';
    this.visibleAngularEditor = this.dialog.open(this.angularEditorTextarea, this.angularEditorTextareaConfig);
  }

  okAngularEditorData(editorValue: any) {
    if (this.textareaEditorTitle == "Login Page Content") {
      this.organizationImage.loginpageContent = this.editorValue;
    }
    this.visibleAngularEditor.close();
  }

  cancelAngularEditorData() {
    this.visibleAngularEditor.close();
  }

  /*  :::::::: Update Organization :::::::: */

  validateOrg(organization: any, organizationImage: any) {
    if (organization.minimumPasswordLength && organization.minimumPasswordLength < 8) {
      this.fieldValidation(['minimumPasswordLength']);
      this.showSnackBar('Minimum password length is 8 characters', 'E');
    } else {
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
    }
  }

  updateOneQmsOrganization(organization: any, organizationImage: any) {
    this.isProcessing = true;

    delete organization.createdOn;
    delete organization.updatedOn;

    const orgObj = {
      ...organization,

      sameEmailToMultipleUsers: organization.sameEmailToMultipleUsers ? "Y" : "N",
      isActive: organization.isActive ? "Y" : "N",
      adEnabled: organization.adEnabled ? "Y" : "N",
      stopEmails: organization.stopEmails ? "Y" : "N",
      hideUserName: organization.hideUserName ? "Y" : "N",
      isAllowMobileAccess: organization.isAllowMobileAccess ? "Y" : "N",
      isDocumentPasswordReqd: organization.isDocumentPasswordReqd ? "Y" : "N",
      licenseStartedOn: organization.licenseStartedOn ? this.appService.dateZoneConvertion(new Date(organization.licenseStartedOn)) : null,
      licenseRenewedOn: organization.licenseRenewedOn ? this.appService.dateZoneConvertion(new Date(organization.licenseRenewedOn)) : null,
      licenseExpiryDate: organization.licenseExpiryDate ? this.appService.dateZoneConvertion(new Date(organization.licenseExpiryDate)) : null,
      versionUpgradedOn: organization.versionUpgradedOn ? new Date(organization.versionUpgradedOn) : null,
      ...organization.adEnabled && { adType: this.selectedADType ?? null },
      notificationTimezone: this.selectedTimeZone ?? null,
      userNameFormatAtApplication: this.selectedNameFormatForApp ?? null,
      userNameFormatAtReports: this.selectedNameFormatForRep ?? null,
      dateFormat: this.selectedDateFormat ?? null,
      allowUserInParallelSession: organization.allowUserInParallelSession ? "Y" : "N",
      orgCountries: this.selectedOrgCountries.length ? this.selectedOrgCountries?.join(',') : null,
      /* Update Criteria is intentionally hardcoded as ☻☻☻-- secondary --☻☻☻ to prevent unauthorized modification of license-related configurations.
      For example, if a user uses browser inspect mode to enable disabled fields, they may attempt to override existing license data
      such as file size limits, allowed extensions, and other restricted settings. By enforcing this criteria as secondary,
      the backend (Java) automatically overrides any user-modified values with the default values defined by us (Astakenis),
      ensuring the integrity and security of the configuration */
      updateCriteria: 'secondary'
    }

    this.appService.updateOneQmsOrganization(orgObj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.orgImage(organizationImage);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  orgImage(organizationImage: any) {

    delete organizationImage.createdOn;
    delete organizationImage.updatedOn;

    if (organizationImage.orgId) {

      const orgImageObj = {
        ...organizationImage,
        isLoginImageSquare: this.organizationImage.isLoginImageSquare ? "Y" : "N",
        isReportImageSquare: this.organizationImage.isReportImageSquare ? "Y" : "N",
        isLogoImageSquare: this.organizationImage.isLogoImageSquare ? "Y" : "N",
        logoImageExt: this.logoImgExtension ?? this.organizationImage.logoImageExt,
        loginImageExtn: this.loginImgExtension ?? this.organizationImage.loginImageExtn,
        reportImageExtn: this.reportImgExtension ?? this.organizationImage.reportImageExtn,
        clientUserGuideName: this.clientUserGuideName ?? this.organizationImage.clientUserGuideName,
        clientUserGuideExtension: 'pdf',
        updateReason: this.organization.updateReason,
        operation: 'U',
      };

      const json = JSON.stringify(orgImageObj);
      const blob = new Blob([json], { type: 'application/json' });
      const updateOneQmsOrgImagesData = new FormData();

      // --- LOGO IMAGE ---
      if (this.logoImg instanceof File) {
        updateOneQmsOrgImagesData.append('logoImage', this.logoImg);
      } else if (this.organizationImage?.logoImage) {
        const ext = orgImageObj.logoImageExt || 'png';
        const logoBlob = this.base64ToBlob(this.organizationImage.logoImage, ext);
        updateOneQmsOrgImagesData.append('logoImage', logoBlob, `existing_logo.${ext}`);
      }

      // --- LOGIN IMAGE ---
      if (this.loginImg instanceof File) {
        updateOneQmsOrgImagesData.append('loginImage', this.loginImg);
      } else if (this.organizationImage?.loginImage) {
        const ext = orgImageObj.loginImageExtn || 'png';
        const loginBlob = this.base64ToBlob(this.organizationImage.loginImage, ext);
        updateOneQmsOrgImagesData.append('loginImage', loginBlob, `existing_login.${ext}`);
      }

      // --- REPORT IMAGE ---
      if (this.reportImg instanceof File) {
        updateOneQmsOrgImagesData.append('reportImage', this.reportImg);
      } else if (this.organizationImage?.reportImage) {
        const ext = orgImageObj.reportImageExtn || 'png';
        const reportBlob = this.base64ToBlob(this.organizationImage.reportImage, ext);
        updateOneQmsOrgImagesData.append('reportImage', reportBlob, `existing_report.${ext}`);
      }

      // --- USER GUIDE (PDF) ---
      if (this.clientUserGuide instanceof File) {
        updateOneQmsOrgImagesData.append('userGuide', this.clientUserGuide);
      } else if (this.organizationImage?.clientUserGuide) {
        const ext = 'pdf';
        const userGuideBlob = this.base64ToBlob(this.organizationImage.clientUserGuide, ext);
        updateOneQmsOrgImagesData.append('userGuide', userGuideBlob, `existing_user_guide.${ext}`);
      }

      // Append JSON DTO
      updateOneQmsOrgImagesData.append('oneQmsOrgImagesDto', blob);

      this.appService.updateLogoImage(updateOneQmsOrgImagesData).subscribe({
        next: (Response: any) => {
          Response.resultType == "S" && this.ngOnInit();
          this.visibleInfoPopup.close();
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {

      const orgImageObj = {
        ...organizationImage,
        isLoginImageSquare: this.organizationImage.isLoginImageSquare ? "Y" : "N",
        isReportImageSquare: this.organizationImage.isReportImageSquare ? "Y" : "N",
        isLogoImageSquare: this.organizationImage.isLogoImageSquare ? "Y" : "N",
        oneQmsImageFileName: this.clientUserGuideName || null,
        operation: 'I',
      }
      const json = JSON.stringify(orgImageObj);
      const blob = new Blob([json], { type: 'application/json' });
      const addOneQmsOrgImagesData = new FormData();

      addOneQmsOrgImagesData.append('binaryLogoFile', this.logoImage ?? '');
      addOneQmsOrgImagesData.append('binaryLoginFile', this.loginImage ?? '');
      addOneQmsOrgImagesData.append('binaryReportFile', this.reportImage ?? '');
      addOneQmsOrgImagesData.append('oneQmsOrgImagesDto', blob);

      this.appService.updateLogoImage(addOneQmsOrgImagesData).subscribe({
        next: (Response: any) => {
          Response.resultType == "S" && this.ngOnInit();
          this.visibleInfoPopup.close();
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  private base64ToBlob(base64Data: string, extension: string = 'png'): Blob {
    let mimeType = 'image/png';
    const ext = extension?.toLowerCase().trim();
    if (ext === 'jpg' || ext === 'jpeg') {
      mimeType = 'image/jpeg';
    }

    // 1. Ensure clean base64 format without double prefixes
    const cleanBase64 = base64Data.replace(/^data:image\/\w+;base64,/, '');

    // 2. Decode using atob and convert to Uint8Array directly
    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    // 3. Cast buffer explicitly to ArrayBuffer to satisfy BlobPart type definitions
    return new Blob([byteNumbers.buffer as ArrayBuffer], { type: mimeType });
  }

  /*  :::::::: Report Image :::::::: */

  setReportImagePage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.organizationReportImage.length, page, this.perPage, targetPage);
    if (this.organizationReportImage.length > 0) {
      this.pagedItems1 = this.organizationReportImage.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  reportImagePagination(value: number) {
    this.perPage = value;
    this.setReportImagePage(this.pager.currentPage, 0);
  }

  reportImageColumnSearch(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems1 = this.organizationReportImage.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems1 = this.organizationReportImage.filter((item: any) => {
        const columnValue = item[column];

        if (val === 'date') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        return false;
      });
    }
  }
  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName

    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (response: any) => {
        this.htmlContent = response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      },
      error: (error: any) => {
        console.log(error);
      },

    });
    this.isProcessing = false;

  }


  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  reportImagePopupTitle: string = '';
  openAddReportImagePopup() {
    this.organizationReportImage.reportImage = null;
    this.reportImageView = null;
    this.organizationReportImage.isReportImageSquare = false;
    this.organizationReportImage.useAsDefault = false;
    this.organizationReportImage.reportImageName = '';
    this.isAllModulesSelected = false;
    this.selectedModule = [];
    this.selectedQmsGroup = [];
    this.selectedDmsFolder = [];
    this.addTime = true;
    this.organizationReportImage.reportImageId = '';
    this.organizationReportImage.reportImage = null;
    this.organizationReportImage.moduleRefIds = '';
    this.organizationReportImage.reportImageName = '';
    this.organizationReportImage.reportImageExtn = '';
    this.organizationReportImage.isReportImageSquare = false;
    this.organizationReportImage.useAsDefault = false;
    [this.selectedModule, this.selectedQmsGroup, this.selectedDmsFolder] = [[], [], []];
    this.reportImagePopupTitle = 'Add Report Image';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);

  }

  openEditReportImagePopup(editData: any) {

    this.addTime = false;

    this.selectedModule = editData.applicableModules ? editData.applicableModules.split(",") : [];
    if (this.selectedModule.length) {
      if (this.selectedModule.length == 1) {
        this.singleSelected = this.selectedModule[0];
        this.selectedModule == 'QMS' && (this.selectedQmsGroup = editData.moduleRefIds ? editData.moduleRefIds.split(",").map(Number) : [])
        this.selectedModule == 'DOCS' && (this.selectedDmsFolder = editData.moduleRefIds ? editData.moduleRefIds.split(",").map(Number) : [])
      }
    } else {
      [this.singleSelected, this.selectedQmsGroup, this.selectedDmsFolder] = ['', [], []];
    }

    editData.isReportImageSquare = editData.isReportImageSquare == 'Y';
    editData.useAsDefault = editData.useAsDefault == 'Y';
    this.organizationReportImage = editData;
    this.reportImagePopupTitle = 'Edit Report Image';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  cancelAddOrEditImagePopup() {
    this.visibleAddAndEditPopup.close();
  }

  addAndEditReportImage() {

    const validations = [
      { condition: !this.selectedModule.length, id: 'module-validation' },
      { condition: !this.organizationReportImage.reportImageName, id: 'report-image-name-validation' },
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.showSnackBar('Please enter mandatory fields', 'E');
    } else if (!this.organizationReportImage.reportImage && !this.reportImage) {
      this.showSnackBar('Please select image', 'E');
    } else {
      this.isProcessing = true;
      let refId = null;
      if (this.selectedModule.length === 1) {
        if (this.singleSelected === 'QMS') {
          refId = this.selectedQmsGroup?.join(',')
        } else if (this.singleSelected === 'DOCS') {
          refId = this.selectedDmsFolder?.join(',')
        }
      }
      const obj = {
        applicableModules: this.selectedModule.length ? this.selectedModule.join(',') : '',
        moduleRefIds: refId,
        reportImageName: this.organizationReportImage.reportImageName,
        reportImageExtn: this.organizationReportImage.reportImageExtn,
        isReportImageSquare: this.organizationReportImage.isReportImageSquare ? "Y" : "N",
        useAsDefault: this.organizationReportImage.useAsDefault ? "Y" : "N",
        operation: 'U'
      }

      if (this.organizationReportImage.reportImageId) {
        this.updateReportImage(obj);
      } else {
        this.createReportImage(obj);
      }
    }
  }

  createReportImage(reportImage: any) {

    const json = JSON.stringify(reportImage);
    const blob = new Blob([json], { type: 'application/json' });
    const addOneQmsOrgImagesData = new FormData();

    addOneQmsOrgImagesData.append('binaryReportFile', this.reportImage ?? '');
    addOneQmsOrgImagesData.append('oneQmsOrgReportImagesDto', blob);

    this.appService.addReportImage(addOneQmsOrgImagesData).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.visibleAddAndEditPopup.close();
          this.setOrgReportImageGrid();
        }
        this.isProcessing = false;
        this.showSnackBar(Response.result, Response.resultType);
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  updateReportImage(reportImage: any) {

    const modifiedObj = {
      ...reportImage, reportImageId: this.organizationReportImage.reportImageId,
    }
    const json = JSON.stringify(modifiedObj);
    const blob = new Blob([json], { type: 'application/json' });
    const updateOneQmsOrgImagesData = new FormData();
    if (this.reportImage) {
      updateOneQmsOrgImagesData.append('binaryReportFile', this.reportImage);
      updateOneQmsOrgImagesData.append('oneQmsOrgReportImagesDto', blob);
    } else {
      updateOneQmsOrgImagesData.append('binaryReportFile', this.organizationReportImage.reportImage);
      updateOneQmsOrgImagesData.append('oneQmsOrgReportImagesDto', blob);
    }


    this.appService.updateReportImage(updateOneQmsOrgImagesData).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.visibleAddAndEditPopup.close();
          this.setOrgReportImageGrid();
        }
        this.isProcessing = false;
        this.showSnackBar(Response.result, Response.resultType);
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  openDeleteReportImagePopup(deleteRowData: any) {
    this.organizationReportImage = deleteRowData;
    this.organizationReportImage.deleteReason = '';
    this.popupDataTitle.title = "Delete Report Image";

    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  cancelDeleteReportImagePopup() {
    this.visibleDeletePopup.close();
  }

  deleteReportImage() {
    if (this.organizationReportImage.deleteReason) {
      delete this.organizationReportImage.createdOn;
      delete this.organizationReportImage.updatedOn;

      this.appService.deleteReportImage(this.organizationReportImage).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.visibleDeletePopup.close();
            this.setOrgReportImageGrid();
          }
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.fieldValidation(['deleteTextarea']);
      this.showSnackBar('Please provide delete reason', 'E');
    }
  }


  /*  :::::::: IP Address :::::::: */

  setIPGrid() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "IP_REGISTRATION",
    }
    this.isProcessing = true;
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "IP_REGISTRATION",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          module: null,
          groupId: null,
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  previousSelectedValue: any;
  copyingFieldData: any = [];
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.grid[this.previousSelectedValue].childCheckBox = false;
      }
      list.childCheckBox = true;
    } else {
      list.childCheckBox = false;
    }
    this.previousSelectedValue = idx;
    this.visibleAuditTrail = this.grid.some((list: any) => list.childCheckBox);
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      this.onChildChecked(list);
    } else {
      this.parentCheckBox = list.childCheckBox = false;
      this.isCopyingFlexibleFields && this.onChildUnchecked(list);
    }
  }

  onChildChecked(checked: any) {
    if (!this.isCopyingFlexibleFields) {
      this.grid.every((item: any) => { if (item.childCheckBox) { item.childCheckBox = false; } return true; })
      checked.childCheckBox = true;
    } else if (!this.copyingFieldData?.some((copied: any) => copied.FIELD_ID === checked.FIELD_ID)) {
      this.copyingFieldData.push(checked);
      if (this.grid.every((r: any) => r.childCheckBox)) { this.parentCheckBox = true; }
    }
  }

  onChildUnchecked(unchecked: any) {
    const removal = this.copyingFieldData?.findIndex((copied: any) => copied.FIELD_ID == unchecked.FIELD_ID);
    if (removal > -1) this.copyingFieldData?.splice(removal, 1);
  }

  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  refreshGridData() {
    this.setIPGrid();
  }

  getClobData1(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (response: any) => {
        this.htmlContent = response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      },
      error: (error: any) => {
        console.log(error);
      }
    });
    this.isProcessing = false;

  }

  ipPopupTitle: string = '';
  openIPAddPopup() {
    this.justification = this.ipAddress = this.allowedTill = null;
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.ipPopupTitle = 'Add IP Address'
    this.visibleAddAndEditPopupDynamic = this.dialog.open(this.addAndEditDynamicPopup, this.addAndEditPopupDynamicConfig);
  }

  editingFieldId: any;
  openIPEditPopup(editingFieldId: any) {
    this.justification = editingFieldId.JUSTIFICATION;
    this.ipAddress = editingFieldId.IP_ADDRESS;
    this.allowedTill = editingFieldId.ALLOWED_TILL;
    this.popupTitle = "Update IPAddress";
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.visibleAddAndEditPopupDynamic = this.dialog.open(this.addAndEditDynamicPopup, this.addAndEditPopupDynamicConfig);
  }

  addOrEditIP() {
    const validations = [
      { condition: !this.ipAddress, id: 'ip-validation' },
      { condition: !this.justification, id: 'justification-validation' },
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.showSnackBar('Please enter mandatory fields', 'E');
    } else {

      const ipObj = {
        justification: this.justification,
        ipAddress: this.ipAddress,
        allowedTill: this.allowedTill ? this.appService.dateZoneConvertion(new Date(this.allowedTill)) : null,
        operation: 'I'
      }

      if (this.visibleAddButton) {
        this.appService.addIpAddress(ipObj).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.visibleAddAndEditPopupDynamic.close();
              this.setIPGrid();
            }
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        const modifiedObj = {
          ...ipObj, operation: 'U'
        }

        this.appService.updateIpAddress(modifiedObj).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.visibleAddAndEditPopupDynamic.close();
              this.setIPGrid();
            }
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddOrEditIPPopup() {
    this.visibleAddAndEditPopupDynamic.close();
  }

  openIPDeletePopup(deleting: any) {
    this.orgIpAddress.deleteReason = '';
    this.justification = deleting.JUSTIFICATION;
    this.ipAddress = deleting.IP_ADDRESS;
    this.allowedTill = deleting.ALLOWED_TILL;
    this.visibleDeletePopupDynamic = this.dialog.open(this.deleteDynamicPopup, this.deletePopupDynamicConfig);
  }

  deleteIP() {
    if (this.orgIpAddress.deleteReason) {
      const obj = {
        ipAddress: this.ipAddress,
        deleteReason: this.orgIpAddress.deleteReason,
        justification: this.justification,
        allowedTill: this.allowedTill ? this.appService.dateZoneConvertion(new Date(this.allowedTill)) : null,
        operation: 'D'
      }
      this.appService.deleteIpAddress(obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.setIPGrid();
            this.visibleDeletePopupDynamic.close();
          }
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.fieldValidation(['delete-reason']);
      this.showSnackBar('Please provide delete reason', 'E');
    }
  }

  cancelIPDeletePopup() {
    this.visibleDeletePopupDynamic.close();
  }


  /*  :::::::: Reports :::::::: */

  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;
  reportPopupConfig = {
    width: '60%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  reportType: string = '';
  report(reportType: string) {
    this.reportType = reportType;
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
  }

  closeReportPopup() {
    this.visibleReportPopup.close();
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  openReport(reportType: string, index: number) {

    const $TableName_Mapping: Record<number, string> = {
      0: 'ONEQMS_ORGS_VW', 1: 'ONEQMS_ORG_PRIVS', 2: 'ONEQMS_ORG_IMAGES_VW', 3: 'ONEQMS_ORG_IMAGES_VW'
    };

    const $DBList_Mapping: Record<number, string> = {
      0: `ORG_SHORT_NAME,ORG_LONG_NAME,APPLICATION_NAME,APPLICATION_URL,VERSION_UPGRADED_ON,CURRENT_VERSION,USER_SESSION_TIMEOUT_IN_MINS,MINIMUM_USERNAME_LENGTH,MINIMUM_PASSWORD_LENGTH,USER_PWD_EXPIRY,REUSE_PWD_CYCLE,LOGIN_ATTEMPTS,EMAIL_DOMAINS,SAME_EMAIL_TO_MULTIPLE_USERS,NOTIFICATION_TIMEZONE,IS_ACTIVE,STOP_EMAILS,USER_NAME_FORMAT_AT_APPLICATION,USER_NAME_FORMAT_AT_REPORTS,DATE_FORMAT,ALLOWED_FILE_EXTNS,ALLOWED_FILE_SIZE_IN_MB,ALLOW_USER_IN_PARALLEL_SESSION,AD_ENABLED,AD_TYPE,IS_AD_AUTHENTICATION_FORCED_AT_LOGIN,IS_AD_AUTHENTICATION_FORCED_AT_APPROVALS,LICENSE_STARTED_ON,LICENSE_RENEWED_ON,LICENSE_EXPIRY_DATE,LICENSE_WARNING_PERIOD_IN_DAYS,ORG_COUNTRIES_NAME,HIDE_USER_NAME,IS_ALLOW_MOBILE_ACCESS,MAX_PARALLEL_DOCUMENT_UPLOADS,IS_DOCUMENT_PASSWORD_REQD,CREATED_BY_USER,CREATED_ON,UPDATED_BY_USER,UPDATED_ON,UPDATE_REASON`,
      1: 'CONCURRENT_USER_COUNT,QUALITY_USER_COUNT,CR,CAPA,DV,AU,"IN",QI,CC,OOS,QUALITY_TASK_COUNT,TRN,TRN_USER_COUNT,DOCS,DOCS_USER_COUNT,FORMS_AND_LOGS,FORMS_AND_LOGS_COUNT,BP,BP_SETUP_COUNT,CREATED_ON,UPDATED_ON,UPDATE_REASON',
      2: 'LOGINPAGE_CONTENT,LOGIN_IMAGE,LOGIN_IMAGE_EXTN,IS_LOGIN_IMAGE_SQUARE,LOGO_IMAGE,LOGO_IMAGE_EXTN,IS_LOGO_IMAGE_SQUARE,REPORT_IMAGE,REPORT_IMAGE_EXTN,IS_REPORT_IMAGE_SQUARE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON',
      3: 'REPORT_HEADER_COLOR_CODE,REPORT_HEADER_FONT_COLOR_CODE,REPORT_SUBHEADER_COLOR_CODE,REPORT_SUBHEADER_FONT_COLOR_CODE,REPORT_LABEL_COLOR_CODE,REPORT_LABEL_FONT_COLOR_CODE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON'
    };

    const $ReportList_Mapping: Record<number, string> = {
      0: `Organization Short Name,Organization Long Name,Application Display Name,Application URL,Version Upgraded On,Current Version,User Session Timeout In Minutes,Minimum Username Length,Minimum Password Length,User Password Expiry (In Days),Reuse Password Cycle (In Days),Allowed Failed Login Attempts,Email Domain(s),Allow Multiple Users to Use Same Email?,Reports Timezone,Is Active?,Stop Emails?,Username Format At Application,Username Format At Reports,Date Format,Allowed File Extensions,Allowed File Size (In MB),Override User Session,Active Directory Enabled,Active Directory Type,Is AD Authentication Forced At Login,Is AD Authentication Forced At Approvals,License Started On,License Renewed On,License Expiry Date,License Warning Period (In Days),Location,Hide User Name,Is Allow Mobile Access,Max Parallel Documents Upload Count,Enable Password Authentication for Document Downloads,Created By,Created On,Updated By,Updated On,Update Reason`,
      1: 'Concurrent User Count,Quality User Count,CR,CAPA,DV,AU,IN,QI,CC,OOS,Quality Task Count,Trainings,Trainings User Count,Documents,Documents User Count,Forms And Logs,Forms And Logs Count,Business Process,Business Process Count,Created On,Updated On,Update Reason',
      2: 'Loginpage Content,Login Image,Login Image Extension,Is Login Image Square,Logo Image,Logo Image Extension,Is Logo Image Square,Report Image,Report Image Extension,Is Report Image Square,Created On,Created By,Updated On,Updated By,Update Reason',
      3: 'Header Color,Header Font Color,Sub Header Color,Sub Header Font Color,Label Color,Label Font Color,Created On,Created By,Updated On,Updated By,Update Reason'
    };

    const $Title_Mapping: Record<number, string> = {
      0: 'Organization', 1: 'License and Privileges', 2: 'Images', 3: 'Report Color Codes'
    };

    const $manualEntryDataFields: Record<number, string> = {
      0: 'LICENSE_STARTED_ON,LICENSE_RENEWED_ON,LICENSE_EXPIRY_DATE', 1: ' ', 2: ' ', 3: ' '
    };
    this.excelPdf.tableOrView_Name = $TableName_Mapping[index];
    this.excelPdf.columnList_DB = $DBList_Mapping[index];
    this.excelPdf.columnList_Report = $ReportList_Mapping[index];
    this.excelPdf.whereClause_Report = ' WHERE ORG_ID = ' + this.message.getOrgId();
    this.excelPdf.reportType = 'Static';
    this.excelPdf.manualEntryDataFields = $manualEntryDataFields[index];
    this.excelPdf.reportName = 'OneQms ' + $Title_Mapping[index] + ' Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

  openImageReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "ONEQMS_ORG_REPORT_IMAGES_VW";
    this.excelPdf.columnList_DB = "REPORT_IMAGE_NAME,REPORT_IMAGE_EXTN,APPLICABLE_MODULES,MODULE_REF_NAME,IS_REPORT_IMAGE_SQUARE,USE_AS_DEFAULT,CREATED_ON,UPDATED_ON,CREATED_BY_USER,UPDATED_BY_USER";
    this.excelPdf.columnList_Report = "Report Image Name,Report Image Extn,Applicable Modules,Module Ref Name,Is Report Image Square,Use As Default,Created On,Updated On,Created By,Updated By";
    this.excelPdf.whereClause_Report = '';
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'OneQms Organization Report Image Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

  openIPReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'IP Address Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }


  /*  :::::::: Audit Trail :::::::: */

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;
  @ViewChild('trailPopup', { static: true }) trailPopup: TemplateRef<any>;
  visibleTrailPopup: MatDialogRef<TemplateRef<any>>;
  trailPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  openAuditTrail() {
    this.visibleTrailPopup = this.dialog.open(this.trailPopup, this.trailPopupConfig);
  }

  closeTrailPopup() {
    this.visibleTrailPopup.close();
  }

  triggerAuditTrail(index: number) {

    const $TableName_Mapping: Record<number, string> = {
      0: 'ONEQMS_ORGS_AU_VW', 1: 'ONEQMS_ORG_PRIVS_AU', 2: 'ONEQMS_ORG_IMAGES_AU_VW', 3: 'ONEQMS_ORG_IMAGES_AU_VW'
    };

    const $DBList_Mapping: Record<number, string> = {
      0: `CREATED_TS,END_TS,ACTION_FLAG,ORG_SHORT_NAME,ORG_LONG_NAME,APPLICATION_NAME,APPLICATION_URL,VERSION_UPGRADED_ON,CURRENT_VERSION,USER_SESSION_TIMEOUT_IN_MINS,MINIMUM_USERNAME_LENGTH,MINIMUM_PASSWORD_LENGTH,USER_PWD_EXPIRY,REUSE_PWD_CYCLE,LOGIN_ATTEMPTS,EMAIL_DOMAINS,SAME_EMAIL_TO_MULTIPLE_USERS,NOTIFICATION_TIMEZONE,IS_ACTIVE,STOP_EMAILS,USER_NAME_FORMAT_AT_APPLICATION,USER_NAME_FORMAT_AT_REPORTS,DATE_FORMAT,ALLOWED_FILE_EXTNS,ALLOWED_FILE_SIZE_IN_MB,ALLOW_USER_IN_PARALLEL_SESSION,AD_ENABLED,AD_TYPE,IS_AD_AUTHENTICATION_FORCED_AT_LOGIN,IS_AD_AUTHENTICATION_FORCED_AT_APPROVALS,LICENSE_STARTED_ON,LICENSE_RENEWED_ON,LICENSE_EXPIRY_DATE,LICENSE_WARNING_PERIOD_IN_DAYS,ORG_COUNTRIES_NAME,HIDE_USER_NAME,IS_ALLOW_MOBILE_ACCESS,MAX_PARALLEL_DOCUMENT_UPLOADS,IS_DOCUMENT_PASSWORD_REQD,CREATED_BY_USER,CREATED_ON,UPDATED_BY_USER,UPDATED_ON,UPDATE_REASON`,
      1: 'CREATED_TS,END_TS,ACTION_FLAG,CONCURRENT_USER_COUNT,QUALITY_USER_COUNT,CR,CAPA,DV,AU,"IN",QI,CC,OOS,QUALITY_TASK_COUNT,TRN,TRN_USER_COUNT,DOCS,DOCS_USER_COUNT,FORMS_AND_LOGS,FORMS_AND_LOGS_COUNT,BP,BP_SETUP_COUNT,CREATED_ON,UPDATED_ON,UPDATE_REASON',
      2: 'CREATED_TS,END_TS,ACTION_FLAG,LOGINPAGE_CONTENT,LOGIN_IMAGE,LOGIN_IMAGE_EXTN,IS_LOGIN_IMAGE_SQUARE,LOGO_IMAGE,LOGO_IMAGE_EXTN,IS_LOGO_IMAGE_SQUARE,REPORT_IMAGE,REPORT_IMAGE_EXTN,IS_REPORT_IMAGE_SQUARE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON',
      3: 'CREATED_TS,END_TS,ACTION_FLAG,REPORT_HEADER_COLOR_CODE,REPORT_HEADER_FONT_COLOR_CODE,REPORT_SUBHEADER_COLOR_CODE,REPORT_SUBHEADER_FONT_COLOR_CODE,REPORT_LABEL_COLOR_CODE,REPORT_LABEL_FONT_COLOR_CODE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON'
    };

    const $UIList_Mapping: Record<number, string> = {
      0: `Created Timestamp,End Timestamp,Action Flag,Organization Short Name,Organization Long Name,Application Display Name,Application URL,Version Upgraded On,Current Version,User Session Timeout In Minutes,Minimum Username Length,Minimum Password Length,User Password Expiry (In Days),Reuse Password Cycle (In Days),Allowed Failed Login Attempts,Email Domain(s),Allow Multiple Users to Use Same Email?,Reports Timezone,Is Active?,Stop Emails?,Username Format At Application,Username Format At Reports,Date Format,Allowed File Extensions,Allowed File Size (In MB),Override User Session,Active Directory Enabled,Active Directory Type,Is AD Authentication Forced At Login,Is AD Authentication Forced At Approvals,License Started On,License Renewed On,License Expiry Date,License Warning Period (In Days),Location,Hide User Name,Is Allow Mobile Access,Max Parallel Documents Upload Count,Enable Password Authentication for Document Downloads,Created By,Created On,Updated By,Updated On,Update Reason`,
      1: 'Created Timestamp,End Timestamp,Action Flag,Concurrent User Count,Quality User Count,CR,CAPA,DV,AU,IN,QI,CC,OOS,Quality Task Count,Trainings,Trainings User Count,Documents,Documents User Count,Forms And Logs,Forms And Logs Count,Business Process,Business Process Count,Created On,Updated On,Update Reason',
      2: 'Created Timestamp,End Timestamp,Action Flag,Loginpage Content,Login Image,Login Image Extension,Is Login Image Square,Logo Image,Logo Image Extension,Is Logo Image Square,Report Image,Report Image Extension,Is Report Image Square,Created On,Created By,Updated On,Updated By,Update Reason',
      3: 'Created Timestamp,End Timestamp,Action Flag,Header Color,Header Font Color,Sub Header Color,Sub Header Font Color,Label Color,Label Font Color,Created On,Created By,Updated On,Updated By,Update Reason'
    };

    const $ReportList_Mapping: Record<number, string> = {
      0: `Created Timestamp,End Timestamp,Action Flag,Organization Short Name,Organization Long Name,Application Display Name,Application URL,Version Upgraded On,Current Version,User Session Timeout In Minutes,Minimum Username Length,Minimum Password Length,User Password Expiry (In Days),Reuse Password Cycle (In Days),Allowed Failed Login Attempts,Email Domain(s),Allow Multiple Users to Use Same Email?,Reports Timezone,Is Active?,Stop Emails?,Username Format At Application,Username Format At Reports,Date Format,Allowed File Extensions,Allowed File Size (In MB),Override User Session,Active Directory Enabled,Active Directory Type,Is AD Authentication Forced At Login,Is AD Authentication Forced At Approvals,License Started On,License Renewed On,License Expiry Date,License Warning Period (In Days),Location,Hide User Name,Is Allow Mobile Access,Max Parallel Documents Upload Count,Enable Password Authentication for Document Downloads,Created By,Created On,Updated By,Updated On,Update Reason`,
      1: 'Created Timestamp,End Timestamp,Action Flag,Concurrent User Count,Quality User Count,CR,CAPA,DV,AU,IN,QI,CC,OOS,Quality Task Count,Trainings,Trainings User Count,Documents,Documents User Count,Forms And Logs,Forms And Logs Count,Business Process,Business Process Count,Created On,Updated On,Update Reason',
      2: 'Created Timestamp,End Timestamp,Action Flag,Loginpage Content,Login Image,Login Image Extension,Is Login Image Square,Logo Image,Logo Image Extension,Is Logo Image Square,Report Image,Report Image Extension,Is Report Image Square,Created On,Created By,Updated On,Updated By,Update Reason',
      3: 'Created Timestamp,End Timestamp,Action Flag,Header Color,Header Font Color,Sub Header Color,Sub Header Font Color,Label Color,Label Font Color,Created On,Created By,Updated On,Updated By,Update Reason'
    };

    const $Title_Mapping: Record<number, string> = {
      0: 'Organization', 1: 'License and Privileges', 2: 'Images', 3: 'Report Color Codes'
    };

    const $manualEntryDataFields: Record<number, string> = {
      0: 'LICENSE_STARTED_ON,LICENSE_RENEWED_ON,LICENSE_EXPIRY_DATE', 1: ' ', 2: ' ', 3: ' '
    };

    this.message.tableOrView_Name = $TableName_Mapping[index];
    this.message.columnList_DB = $DBList_Mapping[index];
    this.message.columnList_UI = $UIList_Mapping[index];
    this.message.manualEntryDataFields = $manualEntryDataFields[index];
    this.message.whereClause_AU = ""
    this.message.columnList_Report = $ReportList_Mapping[index];
    this.message.whereClause_Report = ' WHERE ORG_ID = ' + this.message.getOrgId();
    this.message.report_And_Popup_Name = 'OneQms ' + $Title_Mapping[index] + ' Audit Trail';
    this.staticAuditTrailComponent.triggerTrail(0);
  }

  openImageTrail(viewType: any, image: any) {
    this.message.tableOrView_Name = "ONEQMS_ORG_REPORT_IMAGES_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,REPORT_IMAGE_NAME,REPORT_IMAGE_EXTN,APPLICABLE_MODULES,MODULE_REF_NAME,IS_REPORT_IMAGE_SQUARE,USE_AS_DEFAULT,CREATED_ON,UPDATED_ON,CREATED_BY_USER,UPDATED_BY_USER,DELETED_BY_USER,DELETED_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action,Report Image Name,Report Image Extn,Applicable Modules,Module Ref Name,Is Report Image Square,Use As Default,Created On,Updated On,Created By,Updated By,Deleted By,Deleted Reason";
    this.message.whereClause_AU = viewType == 'overAll' ? ' AND ORG_ID = ' + this.message.getOrgId() : ' AND ORG_ID = ' + this.message.getOrgId() + ' AND REPORT_IMAGE_ID = ' + image.reportImageId; /* x○x○x○x○x○ PENDING x○x○x○x○x○ */
    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action,Report Image Name,Report Image Extn,Applicable Modules,Module Ref Name,Is Report Image Square,Use As Default,Created On,Updated On,Created By,Updated By,Deleted By,Deleted Reason";
    this.message.whereClause_Report = viewType == 'overAll' ? ' WHERE ORG_ID = ' + this.message.getOrgId() : ' WHERE ORG_ID = ' + this.message.getOrgId() + ' AND REPORT_IMAGE_ID = ' + image.reportImageId; /* x○x○x○x○x○ PENDING x○x○x○x○x○ */
    this.message.report_And_Popup_Name = "OneQms Report Image Audit Trail";
    this.staticAuditTrailComponent.triggerTrail(image);
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {};

  openIPTrail(viewType: any, riskScale: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : riskScale.RISK_ID; /* x○x○x○x○x○ PENDING x○x○x○x○x○ */
    this.auditTrail.gridName = 'IP_REGISTRATION';
    this.auditTrail.report_And_Popup_Name = 'IP Address Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(riskScale);
  }


  /*  :::::::: Other Configurations  :::::::: */


  selectedDepartmentValueExp: any;
  onIsActiveChange(event: MatSlideToggleChange) {
    const isActive = event.checked;
    if (isActive || !isActive) {
      this.organization.inactiveReason = '';
    }
  }
  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onDocCountInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = Number(input.value);

    if (Number.isNaN(value)) {
      input.value = '';
      return;
    }

    if (value < 2) {
      input.value = '2';
    } else if (value > 10) {
      input.value = '10';
      this.showSnackBar('Up to 10 documents can be uploaded in parallel; the rest will be queued.', 'E')
    }

    this.organization.maxParallelUploadDocuments = Number(input.value);
  }

  onTimeoutInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = Number(input.value);

    if (Number.isNaN(value)) {
      input.value = '';
      return;
    }

    if (value < 1) {
      input.value = '1';
    } else if (value > 60) {
      input.value = '60';
      this.showSnackBar('Max is 60 minutes', 'E')
    }

    this.organization.userSessionTimeoutInMins = Number(input.value);
  }


  licenseExpiryDateValue: any;
  licenseExpiryDateMsg: any;
  licenseExpiryValidation() {
    this.licenseExpiryDateValue = document.getElementById("licenseExpiryDate") as HTMLInputElement;
    this.licenseExpiryDateMsg = document.getElementById('licenseExpiryDate-required-msg') as HTMLInputElement;
  }


  popupDataTitle: PopupData = {
    title: ''
  };

  imageUploadFlag: any;
  uploadInputFiledValue: any;
  imageFlag: any;
  openLogoImageUploadPopup() {
    this.popupDataTitle.title = "Organization Logo";
    this.imageUploadFlag = "Organization";
    this.imageFlag = 'Logo';
    this.visibleUploadImagesPopup = this.dialog.open(this.uploadImagesPopup, this.uploadImagesPopupConfig);
  }

  openLoginImageUploadPopup() {
    this.popupDataTitle.title = "Organization Login";
    this.imageUploadFlag = "Login";
    this.imageFlag = 'Login';
    this.visibleUploadImagesPopup = this.dialog.open(this.uploadImagesPopup, this.uploadImagesPopupConfig);
  }

  openReportImageUploadPopup(val: any) {
    this.imageTy = val;
    this.popupDataTitle.title = "Report Logo";
    this.imageUploadFlag = "ReportLogo";
    this.imageFlag = 'ReportLogo';
    this.visibleUploadImagesPopup = this.dialog.open(this.uploadImagesPopup, this.uploadImagesPopupConfig);
  }

  loginImage: File | null = null;
  logoImage: File | null = null;
  reportImage: File | null = null;

  imageToUpload: File | null = null;
  imageExtention: any;
  logoSuccessMsg: any;
  logoSuccessIcon: any;
  loginImagename: any;
  loginSuccessMsg: any;
  loginSuccessIcon: any;
  reportImgSuccessMsg: any;
  reportImgSuccessIcon: any;
  uploadErrorMsg: any;
  uploadErrorIcon: any;
  uploadRequiredMsg: any;
  uploadRequiredIcon: any;

  @ViewChild('fileInputMain') fileInputMain: ElementRef<HTMLInputElement>;

  openImageDialog() {
    this.fileInputMain.nativeElement.click();
  }

  logoImg: File | null = null;
  logoImgPreview: string | null = null;
  logoImgExtension: string | null = null;

  loginImg: File | null = null;
  loginImgPreview: string | null = null;
  loginImgExtension: string | null = null;

  reportImg: File | null = null;
  reportImgPreview: string | null = null;
  reportImgExtension: string | null = null;

  clientUserGuide: File | null = null;
  clientUserGuideName: string | null = null;
  clientUserGuideViewer: any = {};

  @ViewChild('orgFile') orgFile: ElementRef<HTMLInputElement>;
  imageWorkingFor: string = '';
  triggerFileSelection(workingFor: string) {
    if (workingFor.includes('remove')) {
      if (workingFor == 'logo-remove') {
        if (this.logoImg) {
          this.logoImg = this.logoImgPreview = this.logoImgExtension = null;
        } else {
          this.organizationImage.logoImage = this.organizationImage.logoImageExt = null;
        }
      } else if (workingFor == 'login-remove') {
        if (this.loginImg) {
          this.loginImg = this.loginImgPreview = this.loginImgExtension = null;
        } else {
          this.organizationImage.loginImage = this.organizationImage.loginImageExtn = null;
        }
      } else if (workingFor == 'report-remove') {
        if (this.reportImg) {
          this.reportImg = this.reportImgPreview = this.reportImgExtension = null;
        } else {
          this.organizationImage.reportImage = this.organizationImage.reportImageExtn = null;
        }
      } else if (workingFor == 'user-guide-remove') {
        if (this.clientUserGuide) {
          this.clientUserGuide = null;
          this.clientUserGuideViewer = {};
        } else {
          this.organizationImage.clientUserGuide = this.organizationImage.clientUserGuideExtension = this.organizationImage.clientUserGuideName = null;
        }
      }
    } else {
      this.imageWorkingFor = workingFor;
      this.orgFile.nativeElement.click();
    }
  }

  chooseFile(event: any) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      event.preventDefault();
      return;
    }

    const extension: string = (event.target.files[0].name.split('.').pop() ?? '').toLowerCase();
    const maxSizeMb = 5;
    const maxSizeBytes = maxSizeMb * 1024 * 1024;
    const file = input.files[0];
    const fileSizeBytes = file.size;

    if (this.imageWorkingFor.includes('user-guide')) {
      if (extension != 'pdf') {
        setTimeout(() => { this.showSnackBar("Dear User, only PDF file can be uploaded as a User Guide", 'E'); });
        event.preventDefault();
        return;
      } else if (fileSizeBytes > maxSizeBytes) {
        setTimeout(() => { this.showSnackBar("Dear User, Max size allowed size is 5 MB", 'E'); });
        event.preventDefault();
        return;
      } else {
        this.executeFile(event);
      }
    } else {
      this.executeFile(event);
    }
  }

  executeFile(event: any) {
    const extension: string = (event.target.files[0].name.split('.').pop() ?? '').toLowerCase();
    const file: File = event.target.files[0];

    if (this.imageWorkingFor.includes('logo')) {
      this.logoImg = file;
      this.logoImgPreview = URL.createObjectURL(file);
      this.logoImgExtension = extension;
    } else if (this.imageWorkingFor.includes('login')) {
      this.loginImg = file;
      this.loginImgPreview = URL.createObjectURL(file);
      this.loginImgExtension = extension;
    } else if (this.imageWorkingFor.includes('report')) {
      this.reportImg = file;
      this.reportImgPreview = URL.createObjectURL(file);
      this.reportImgExtension = extension;
    } else if (this.imageWorkingFor.includes('user-guide')) {
      this.clientUserGuide = file;
      this.clientUserGuideViewer = {
        body: this.clientUserGuide,
        contentType: 'application/pdf',
        extn: 'pdf'
      }
    }
  }

  chooseImage(e: any) {
    if (this.imageUploadFlag == 'Organization') {
      this.imageExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();
      this.logoSuccessMsg = document.getElementById('logo-success-msg') as HTMLInputElement;
      this.logoSuccessIcon = document.getElementById('logo-success-icon') as HTMLInputElement;
    }
    if (this.imageUploadFlag == 'Login' || this.imageUploadFlag == 'ReportLogo') {
      this.imageExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();
      this.loginSuccessMsg = document.getElementById('login-success-msg') as HTMLInputElement;
      this.loginSuccessIcon = document.getElementById('login-success-icon') as HTMLInputElement;
    }
    if (this.imageUploadFlag == 'ReportLogo') {
      this.imageExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();
      this.reportImgSuccessMsg = document.getElementById('report-success-msg') as HTMLInputElement;
      this.reportImgSuccessIcon = document.getElementById('report-success-icon') as HTMLInputElement;
    }

    this.uploadErrorMsg = document.getElementById('logo-error-msg') as HTMLInputElement;
    this.uploadErrorIcon = document.getElementById('logo-error-icon') as HTMLInputElement;

    this.uploadRequiredMsg = document.getElementById('logo-required-msg') as HTMLInputElement;
    this.uploadRequiredIcon = document.getElementById('logo-required-icon') as HTMLInputElement;

    if (this.imageExtention != "jpg" && this.imageExtention != "png" && this.imageExtention != "jpeg") {
      if (this.imageUploadFlag == 'Organization') {
        this.logoSuccessMsg.style.display = 'none';
        this.logoSuccessIcon.style.display = 'none';
      }
      if (this.imageUploadFlag == 'Login' || this.imageUploadFlag == 'ReportLogo') {
        this.loginSuccessMsg.style.display = 'none';
        this.loginSuccessIcon.style.display = 'none';
      }
      this.uploadErrorMsg.style.display = 'block';
      this.uploadErrorIcon.style.display = 'block';

      this.uploadRequiredMsg.style.display = 'none';
      this.uploadRequiredIcon.style.display = 'none';
    } else {

      if (this.imageUploadFlag == 'Organization') {
        this.logoImage = e.target.files[0];
        this.organizationImage.logoImageExt = this.imageExtention;
        this.logoSuccessMsg.style.display = 'block';
        this.logoSuccessIcon.style.display = 'flex';
        this.logoSuccessIcon.style.justifyContent = 'center';
      }
      if (this.imageUploadFlag == 'Login') {
        this.loginImage = e.target.files[0];
        this.loginImagename = this.loginImage?.name;
        this.organizationImage.loginImageExtn = this.imageExtention;
        this.loginSuccessMsg.style.display = 'block';
        this.loginSuccessIcon.style.display = 'flex';
        this.loginSuccessIcon.style.justifyContent = 'center';
      }
      if (this.imageUploadFlag == 'ReportLogo') {
        this.reportImage = e.target.files[0];
        this.organizationImage.reportImageExtn = this.imageExtention;
        this.reportImgSuccessMsg.style.display = 'block';
        this.reportImgSuccessIcon.style.display = 'flex';
        this.reportImgSuccessIcon.style.justifyContent = 'center';
      }
      this.uploadErrorMsg.style.display = 'none';
      this.uploadErrorIcon.style.display = 'none';

      this.uploadRequiredMsg.style.display = 'none';
      this.uploadRequiredIcon.style.display = 'none';

      this.visibleUploadImagesPopup.close();
    }
    const file: File = e.target.files[0];
    if (file) {
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "IMAGE");
      formData.append("fileName", name);
      formData.append("extension", extension);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData).subscribe({
        next: (response: any) => {
          this.isProcessing = false;
          if (response.resultType != 'S') {
            this.showSnackBar(response.result, response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }

  }

  @ViewChild('fileInput2') fileInput2: ElementRef<HTMLInputElement>;

  openImageDialog2() {
    this.fileInput2.nativeElement.click();
  }

  reportImageView: any;
  chooseImageAdd(e: any) {
    if (this.imageUploadFlag == 'ReportLogo') {
      this.imageExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();
      this.reportImgSuccessMsg = document.getElementById('report-success-msg1') as HTMLInputElement;
      this.reportImgSuccessIcon = document.getElementById('report-success-icon1') as HTMLInputElement;
    }

    this.uploadErrorMsg = document.getElementById('logo-error-msg') as HTMLInputElement;
    this.uploadErrorIcon = document.getElementById('logo-error-icon') as HTMLInputElement;
    this.uploadRequiredMsg = document.getElementById('logo-required-msg') as HTMLInputElement;
    this.uploadRequiredIcon = document.getElementById('logo-required-icon') as HTMLInputElement;

    if (this.imageExtention != "jpg" && this.imageExtention != "png" && this.imageExtention != "jpeg") {

      if (this.imageUploadFlag == 'ReportLogo') {
        this.loginSuccessMsg.style.display = 'none';
        this.loginSuccessIcon.style.display = 'none';
      }
      this.uploadErrorMsg && (this.uploadErrorMsg.style.display = 'block')
      this.uploadErrorIcon && (this.uploadErrorIcon.style.display = 'block')

      this.uploadRequiredMsg && (this.uploadRequiredMsg.style.display = 'none')
      this.uploadRequiredIcon && (this.uploadRequiredIcon.style.display = 'none')
    } else {
      if (this.imageUploadFlag == 'ReportLogo') {
        this.reportImage = e.target.files[0];
        this.organizationReportImage.reportImageExtn = this.imageExtention;
        this.reportImgSuccessMsg.style.display = 'block';
        this.reportImgSuccessIcon.style.display = 'flex';
        this.reportImgSuccessIcon.style.justifyContent = 'center';
      }
      this.uploadErrorMsg && (this.uploadErrorMsg.style.display = 'none')
      this.uploadErrorIcon && (this.uploadErrorIcon.style.display = 'none')

      this.uploadRequiredMsg && (this.uploadRequiredMsg.style.display = 'none')
      this.uploadRequiredIcon && (this.uploadRequiredIcon.style.display = 'none')

      this.visibleUploadImagesPopup.close();
    }
    const file: File = e.target.files[0];
    const inputFile = document.createElement('input');
    inputFile.type = 'file';
    inputFile.accept = 'image/*';

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.reportImageView = reader.result as string;  // Store base64 string
      };
      reader.readAsDataURL(file);

      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "IMAGE");
      formData.append("fileName", name);
      formData.append("extension", extension);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData).subscribe({
        next: (response: any) => {
          this.isProcessing = false;
          if (response.resultType == 'S') {
            this.addTime = true;
            this.organizationReportImage.reportImageName = name;
          } else {
            this.showSnackBar(response.result, response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelImageFunction() {
    if (this.imageUploadFlag == 'Organization') {
      this.logoImage = null;
    }
    if (this.imageUploadFlag == 'Login') {
      this.loginImage = null;
    }
    this.visibleUploadImagesPopup.close();
  }

  clearLogoImage() {
    this.organizationImage.logoImage = null;
    this.organizationImage.logoImageExt = null;
    this.logoImage = null;
  }

  clearLoginImage() {
    this.organizationImage.loginImage = null;
    this.organizationImage.loginImageExtn = null;
    this.loginImage = null;
  }

  clearReportImage() {
    this.organizationImage.reportImage = null;
    this.organizationImage.reportImageExtn = null;
    this.reportImage = null;
  }
  clearReportImageAdd() {
    this.organizationReportImage.reportImage = null;
    this.organizationReportImage.reportImageExtn = null;
    this.reportImage = null;
  }

  onFieldFocusout() {
    if (this.updateReasonMessageDisplayed) {
      this.updateReasonValue.style.border = 'none';
      this.updateReasonRequiredMsg.style.display = 'none';
    }
    this.updateReasonMessageDisplayed = false;
  }

  updateReasonValue: any;
  minimumPasswordValue: any;

  updateReasonRequiredMsg: any;
  updateReasonMessageDisplayed: any;
  minimumPasswordInvalidMessage: any;
  minimumPasswordMessageDisplayed: any;

  okInfo() {
    this.visibleInfoPopup.close();
  }





  @ViewChild('organizationCountry') organizationCountry: MatSelect;
  isAllOrgCountriesSelected = false;
  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isExeclPdf = ['excel-pdf'].includes(fieldId);
    const isSelected = isExeclPdf ? !selectedItems.length : !selectedItems;
    const isFieldValid = field;
    if (isSelected && isFieldValid) {
      field.style.color = 'red';
    } else {
      field.style.color = '#005c8a';
    }
  }



  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.thirdLevel
          : this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe({
      next: () => {
        this.snackbarRef.dismiss();
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      },
      complete: () => { }
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  error = '';
  visibleAuditTrail: boolean = false;
  dateLovValuesDropdown: any = [];
  isCopyingFlexibleFields: boolean = false;
  parentCheckBox: boolean = false;
  childCheckBox: boolean = false;
  sortedColumn: string = '';
  sortDirection: string = 'asc';

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  onChildValueEmitted() {
    this.setIPGrid();
  };

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() { this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0) }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  addTime: boolean;
  dateCustomClasses: DatepickerDateCustomClasses[];
  color: any;
  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  imageTy = "nonadditional";
  pager: any = {};
  pagedItems: any[];
  pagedItems1: any[];
  popupTitle: string = "";
  oddModuleValue: any = null;
  moduleValueRequiredMsg: any;
  singleSelected: any = "";
  isAllModulesSelected = false;
  oddGroupValue: any = null;
  groupSearchText: any = "";
  groupValueRequiredMsg: any;
  isAllGroupSelected = false;
  oddDocumentsValue: any = null;
  documentsValueRequiredMsg: any;
  isAllDocumentsSelected = false;
  ipAddress: any = null;
  allowedTill: Date | null = null;
  updatedOn: Date | null = null;
  createdOn: Date | null = null;
  justification: any = null;
  warningMsg: any = "";
  pdfSearchText: string = '';
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;

  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;

  formatBytes(mb: number): string {
    const bytes = mb * 1024 * 1024;
    return new Intl.NumberFormat('en-US').format(bytes);
  }

  session: any = [];
  selectBoxForSessionTimeout() {
    this.session = this.sessionArray.map((x: any) => ({
      valueExp: x,
      displayExp: x
    })) ?? []
  }

  onUserActivity(): void {
    this.sessionTimeoutService.notifyActivity();
  }

  viewerData: any = {};

}
